const users = {
  users: {
    pageHeader: 'Utilisateurs',
    addNewUser: '+ Ajouter un nouvel utilisateur',
    name: 'Nom',
    role: 'Rôle',
    company: 'Société',
    status: 'Statut',
    noUser: '** Aucun utilisateur disponible **',
    emailMatch: 'Veuillez saisir à nouveau la même valeur.',
    validEmail: 'Veuillez saisir une adresse email valide.',
    fieldRequired: 'Ce champ est requis.',
    userFormHeader: 'Ajouter des nouveaux utilisateurs',
    userProfile: 'Profil utilisateur',
    defaultEmailHelpText: 'Un email expliquant comment s’inscrire sera envoyé à cette adresse.',
    active: 'Actif',
    email: 'Email',
    confirmEmail: 'Confirmer l’email',
    firstName: 'Prénom',
    lastName: 'Nom',
    phoneNumber: 'Numéro de téléphone',
    preferredLocale: 'Langue préférentielle',
    units: 'Unités',
    addUser: 'Ajouter un utilisateur',
    updateUser: 'Mettre à jour un utilisateur',
    supportTechnician: 'Technicien de support',
    profileAdministrator: 'Administrateur profil',
    profileApprover: 'Validateur de profil',
    administrator: 'Administrateur',
    user: 'Utilisateur',
    viewOnly: 'Lecture seule',
    demonstration: 'Démonstration',
    errorMessageLengthPhone: '50 caractères maximum autorisés',
    all: 'Tous',
    inactive: 'Inactif',
    termsAndServices: 'Seul le propriétaire du système peut permettre l’accès à son site. Sans l’accord par écrit du propriétaire du système, les installateurs ne peuvent pas fournir l’accès à d’autres entreprises ni à des utilisateurs en dehors de leur entreprise. J’ai lu et j’accepte les %{termsService} d’Enphase, et j’ai pris connaissance de %{privacyPolicy} d’Enphase. Je comprends que le non-respect de ces conditions peut entraîner la suspension ou la suppression de mon compte Enlighten.',
    privacyPolicy: 'la politique de confidentialité',
    termsService: 'conditions de service',
  }
};

export default users;
